var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('list-block',[_c('el-form',{ref:"formData",attrs:{"rules":_vm.rules,"inline":true,"model":_vm.formData}},[_c('TaskSetting',{ref:"taskTableEl",attrs:{"node-index":0,"table-data":_vm.formData.taskItemDetails}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }